

import Swal from "sweetalert2";
import api from "../../utilities/interseptor";
import { jwtDecode } from "jwt-decode";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API


export const getUsuariosAdimistrativos = (setUsuariosAdministrativos) => {
    api.get(apiUrl + "/monitor/permisos/getUsuariosAdministrativos").then((res) => {
        setUsuariosAdministrativos(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getPermisos = (setPermisos) => {
    api.get(apiUrl + "/monitor/permisos/todos").then((res) => {
        setPermisos(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getPermisosUsuario = (setPermiso, id_usuario) => {
    api.get(apiUrl + `/monitor/permisos/usuarioEspecifico?id_usuario=${id_usuario}`).then((res) => {
        setPermiso(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const asignarPermiso = (id_usuario, data) => {
    
    
    api.post(apiUrl + `/monitor/permisos/actualizar?id_usuario=${id_usuario}&modulo=${data.code}&privilegio=${data.privilegios}`).then((res) => {


    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTable = (setTableData) => {
    
    
    api.get(apiUrl + `/monitor/permisos/tabla`).then((res) => {
        setTableData(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getInfoUsuario = (setUsuario,id_modulo,id_usuario) => {
    
    
    api.get(apiUrl + `/monitor/permisos/getPermisosByid?id_usuario=${id_usuario}&id_modulo=${id_modulo}`).then((res) => {
        setUsuario(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const updatePermiso = (id_usuario,id_modulo,privilegios,navigate)=>
{

    
    api.patch(apiUrl + `/monitor/permisos/actualizar?id_usuario=${id_usuario}&id_modulo=${id_modulo}&privilegio=${privilegios}`).then((res) => {
        
        navigate("/administrador")
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const agregarPermiso = (id_usuario,item,navigate)=>
{
    
    api.post(apiUrl + `/monitor/permisos/agregar?id_usuario=${id_usuario}&id_modulo=${item.code}&privilegio=${item.privilegios}`).then((res) => {
        
        navigate("/administrador")
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const eliminarPermiso = async (rowData)=>
{

    
    await api.delete(apiUrl + `/monitor/permisos/eliminar?id_usuario=${rowData.ID_USUARIO}&id_modulo=${rowData.ID_MODULO}`).then((res) => {
        
    })
        .catch((error) => {
            console.log("error", error);

        })
}